import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.25 3.75C5.76472 3.75 3.75 5.76472 3.75 8.25C3.75 10.7353 5.76472 12.75 8.25 12.75C10.7353 12.75 12.75 10.7353 12.75 8.25C12.75 5.76472 10.7353 3.75 8.25 3.75ZM2.25 8.25C2.25 4.93629 4.93629 2.25 8.25 2.25C11.5637 2.25 14.25 4.93629 14.25 8.25C14.25 9.63653 13.7797 10.9132 12.9899 11.9292L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L11.9292 12.9899C10.9132 13.7797 9.63653 14.25 8.25 14.25C4.93629 14.25 2.25 11.5637 2.25 8.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }